import { cn } from '@/lib/utils';
import { VariantProps, cva } from 'class-variance-authority';
import React from 'react';

const pillVariants = cva(
  cn('typo-caption bg-system-success-bg text-system-success py-1 px-3 rounded-[20px] inline-flex'),
  {
    variants: {
      variant: {
        default: '',
        neutral: 'bg-light-gray text-secondary-text',
        db: 'bg-pill-db-bg text-pill-db',
        bb: 'bg-pill-bb-bg text-pill-bb',
        ms: 'bg-pill-ms-bg text-pill-ms',
        do: 'bg-pill-do-bg text-pill-do',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

type PillVariantProps = VariantProps<typeof pillVariants>;

interface PillProps extends React.HTMLAttributes<HTMLDivElement>, PillVariantProps {
  text?: string;
}

export const Pill = React.forwardRef<HTMLDivElement, PillProps>(({ className, text, variant, ...props }, ref) => {
  return (
    <div className={cn(pillVariants({ variant }), className)} ref={ref} {...props}>
      {text}
    </div>
  );
});

Pill.displayName = 'Pill';
